import { Button } from "./ui/Button";
import { SkeletonList } from "./ui/Skeleton";

export function LoadingState({ label = "در حال بارگذاری…" }: { label?: string }) {
  return (
    <div className="state-block" role="status" aria-live="polite">
      <span className="spinner" aria-hidden="true" />
      <span className="state-block__title">{label}</span>
    </div>
  );
}

export function LoadingList({ count = 3 }: { count?: number }) {
  return <SkeletonList count={count} />;
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="state-block" role="alert">
      <p className="state-block__title state-block__title--error">خطا در بارگذاری</p>
      <p className="state-block__hint">{message}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          تلاش دوباره
        </Button>
      )}
    </div>
  );
}

export function EmptyState({ message, hint }: { message: string; hint?: string }) {
  return (
    <div className="state-block">
      <p className="state-block__title">{message}</p>
      {hint && <p className="state-block__hint">{hint}</p>}
    </div>
  );
}
